import { render, staticRenderFns } from "./PatientSurveyQuestion.vue?vue&type=template&id=a8b87660&scoped=true"
import script from "./PatientSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./PatientSurveyQuestion.vue?vue&type=script&lang=js"
import style0 from "./PatientSurveyQuestion.vue?vue&type=style&index=0&id=a8b87660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b87660",
  null
  
)

export default component.exports